import { Pipe, PipeTransform } from '@angular/core';
import { IStringAnyMap } from 'lib-boox';

@Pipe({
  name: 'fuzzySearch',
  standalone: true,
})
export class HeroFuzzySearchPipe implements PipeTransform {

  transform(
    items: IStringAnyMap[],
    needleFields: string | string[], // Accept single field or array of fields
    needle: string,
    ...args: any[]
  ): IStringAnyMap[] {
    const filter: any[][] = [];
    if (Array.isArray(args)) {
      for (let i = 0; i < args.length; i += 2) {
        const subFilter = args.slice(i, i + 2);
        if (subFilter.length === 2) {
          filter.push(subFilter);
        }
      }
    }

    const needleLower = needle.toLowerCase();
    const fields = Array.isArray(needleFields) ? needleFields : [needleFields];

    const filterItems = items
      .filter(item => {
        return filter.reduce((acc, filter) => {
          return acc && item[filter[0]] === filter[1];
        }, true);
      });

    return filterItems
      .filter(item => {
        if (needle === '') {
          return true;
        }
        // Check if any field matches the fuzzy search
        return fields.some(field => {
          const valueLower = (item[field] || '').toLowerCase();
          let queryIndex = 0;
          for (const char of valueLower) {
            if (queryIndex < needleLower.length && char === needleLower[queryIndex]) {
              queryIndex++;
            }
          }
          return queryIndex === needleLower.length;
        });
      });
  }
}
